import { Flex, Image, Text } from "@chakra-ui/react";

import { useSearchPage } from "./SearchPageContext";

// Per-city branding as a floating card in the map's upper-left corner —
// mirroring the control cluster in the upper-right. Renders only when the
// page's registry entry provides branding; null context (/Buscar) renders
// nothing. Positioning assumes the map pane's outer position:relative Box.
//
// Always the solid brand backdrop: every city logo is a lockup inherited
// from the legacy pages' dark hero sections (white "guia" wordmark), so a
// light card makes half the artwork vanish. One style, no per-page knobs.
//
// `label`: optional text appended after the logo — for pages whose logo is
// the generic brand mark with no city name in the artwork (ZMG), and the
// fallback pattern for future cities without a bespoke lockup.
//
// Variants: "floating" (default) is the map-corner card. "banner" is a
// full-width strip for mobile LIST view, where the map — and with it the
// floating card — is hidden; rendered by the layout between the site nav
// and the filter bar. Not sticky on purpose: it scrolls away with content
// so the sticky offsets of the bars above/below stay untouched.
const BrandingChip = ({ variant = "floating" }) => {
    const searchPage = useSearchPage();
    const branding = searchPage?.config?.branding;
    if (!branding?.logoSrc) return null;
    const positioning =
        variant === "banner"
            ? { w: "100%", h: "44px", px: 4 }
            : {
                  position: "absolute",
                  top: 4,
                  left: 4,
                  zIndex: 5,
                  h: "40px",
                  px: 3,
                  borderRadius: "md",
                  boxShadow: "md",
              };
    return (
        <Flex
            align="center"
            gap={2}
            bg="colorPalette.solid"
            pointerEvents={branding.href ? "auto" : "none"}
            {...positioning}
            {...(branding.href ? { as: "a", href: branding.href } : {})}
        >
            <Image
                src={branding.logoSrc}
                alt={branding.alt || ""}
                h={variant === "banner" ? "22px" : "26px"}
                maxW="120px"
                objectFit="contain"
            />
            {branding.label && (
                <Text
                    color="colorPalette.contrast"
                    fontWeight={700}
                    fontSize="sm"
                    letterSpacing="0.08em"
                    textTransform="uppercase"
                >
                    {branding.label}
                </Text>
            )}
        </Flex>
    );
};

export default BrandingChip;
